import React from 'react'
import config from '@/config';

const VerifyLogin: React.FC = () => {
  return (
    <div className="verify-login">
      <p className='text-center'>Nếu email sinh viên của bạn sử dụng hệ thống mail của Microsoft / Google thì bạn có thể xác thực bằng cách đăng nhập vào email của bạn qua 2 hình thức bên dưới.</p>
      <a href={config.microsoftLoginUrl} className="verify-login__btn">
        <span className="icon-microsoft" />
        <span>Xác minh bằng Microsoft</span>
      </a>
      <a href={config.googleLoginUrl} className="verify-login__btn">
        <span className="icon-gg" />
        <span>Xác minh bằng Google</span>
      </a>
    </div>
  )
}

export default VerifyLogin
